import { useRoutes } from 'react-router-dom'
import { useState, lazy, Suspense } from 'react'
import { getQuestions } from './services/service'

import HomePage from './pages/home'
const AboutPage = lazy(() => import('./pages/about'))
const SuperheroesPage = lazy(() => import('./pages/superheroes'))
const SuperheroPage = lazy(() => import('./pages/superhero'))
const ResearchPage = lazy(() => import('./pages/research'))
const ContactPage = lazy(() => import('./pages/contact'))
const QuizPage = lazy(() => import('./pages/quiz'))
const QuizPBasket = lazy(() => import('./pages/quiz_pBasket'))
const QuizPhase1 = lazy(() => import('./pages/quiz_phase1'))
const QuizPhase2 = lazy(() => import('./pages/quiz_phase2'))
const QuizResultPage = lazy(() => import('./pages/quiz_result'))
const QuizRelevantPage = lazy(() => import('./pages/quiz_relevant'))
const ErrorPage = lazy(() => import('./pages/error'))
const ComingSoonPage = lazy(() => import('./pages/coming_soon'))

const AppRouter = () => {
  const [pBasket, setPBasket] = useState<string[]>([])

  return useRoutes([
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: '/about',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <AboutPage />
        </Suspense>
      ),
    },
    {
      path: '/superheroes',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <SuperheroesPage />
        </Suspense>
      ),
    },
    {
      path: '/superhero/:id',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <SuperheroPage />
        </Suspense>
      ),
    },
    {
      path: '/research',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <ResearchPage />
        </Suspense>
      ),
    },
    {
      path: '/contact',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <ContactPage />
        </Suspense>
      ),
    },
    {
      path: '/quiz',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <QuizPage />
        </Suspense>
      ),
    },
    {
      path: '/quiz-p',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <QuizPBasket pBasket={pBasket} setPBasket={setPBasket} />
        </Suspense>
      ),
    },
    {
      path: '/quiz-v1',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <QuizPhase1 />
        </Suspense>
      ),
    },
    {
      path: '/quiz-v2',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <QuizPhase2 questions={getQuestions(pBasket)} />
        </Suspense>
      ),
    },
    {
      path: '/quiz-result/:id',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <QuizResultPage />
        </Suspense>
      ),
    },
    {
      path: '/quiz-relevant/:id',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <QuizRelevantPage />
        </Suspense>
      ),
    },
    {
      path: '/coming-soon',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <ComingSoonPage />
        </Suspense>
      ),
    },
    {
      path: '*',
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <ErrorPage />
        </Suspense>
      ),
    },
  ])
}

export default AppRouter
